(() => {
  const SECTION_TYPE = 'footer';

  const initFooter = (container) => {
    if (!container) return;
    
    const headers = container.querySelectorAll('.footer__menu-header');
    headers.forEach(header => {
      header.addEventListener('click', () => {
        if (window.innerWidth > 1024) return;
        const column = header.closest('.footer__menu-column');
        column.classList.toggle('is-open');
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(`[data-section-type="${SECTION_TYPE}"]`).forEach(initFooter);
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target?.dataset?.sectionType !== SECTION_TYPE) return;
    initFooter(event.target);
  });
})();
